import { FormMode } from "enums";
import React from "react";
import AccountTypeVipTiersFormModule from "../account-type-vip-tiers/account-type-vip-tiers-form.module";

const AddAccountTypeVipModule = () => {
  return <AccountTypeVipTiersFormModule pageMode={FormMode.Add} />;
};

export default AddAccountTypeVipModule;
